const unorm = require('unorm');
const intersectionObserver = require('intersection-observer');

exports.onClientEntry = () => {
  // Don't need to do anything here, but if you don't
  // export something, the import won't work.
};
